<template>
    <div class="payment-box">
        <span class="title">결제정보 - {{ index + 1 }}</span>
        <ul class="info-list">
            <li>
                <span class="tit">결제수단 :</span>
                <div class="info">
                    <div class="flex">
                        <div class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-1`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="C"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-1`">카드</label>
                        </div>
                        <div v-if="fitpayMode === 'T'" class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-auto`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="T"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-auto`">핏페이(현장결제)</label>
                        </div>
                        <div v-if="fitpayMode === 'T' || fitpayMode === 'U'" class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-url`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="U"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-url`">핏페이(URL전송)</label>
                        </div>
                        <div class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-2`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="L"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-2`">현금</label>
                        </div>
                        <div class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-3`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="B"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-3`">계좌이체</label>
                        </div>
                        <div v-if="isUseMileage" class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-4`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="M"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-4`">마일리지</label>
                        </div>
                        <div v-if="mode === 'read'" class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-5`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="K"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-5`">키오스크</label>
                        </div>
                        <div class="com-radio">
                            <input
                                :id="`ptype-rdo-${index}-6`"
                                v-model="billData.payType"
                                :disabled="mode === 'read'"
                                :name="`ptype-rdo-${index}`"
                                type="radio"
                                value="E"
                                @change="onChangePayType($event)"
                            />
                            <label :for="`ptype-rdo-${index}-6`">기타</label>
                        </div>
                    </div>

                    <div v-if="billData.payType === 'C'" class="card-radio-box">
                        <div
                            v-for="(card, idx) in cardType"
                            v-show="idx < 9 || isMoreCard"
                            :key="idx"
                            class="com-radio-btn"
                        >
                            <template v-if="(mode === 'read' && card.code === billData.payCardType) || mode !== 'read'">
                                <input
                                    :id="`cType-rdo-${index}-${idx}`"
                                    v-model="billData.payCardType"
                                    :disabled="mode === 'read'"
                                    :name="`cType-rdo-${index}`"
                                    :value="card.code"
                                    type="radio"
                                    @change="onChange"
                                />
                                <label :for="`cType-rdo-${index}-${idx}`">{{ card.title }}</label>
                            </template>
                        </div>
                        <button v-show="cardType.length > 9 && !isMoreCard" class="more-btn" @click="isMoreCard = true">
                            + 더보기
                        </button>
                    </div>
                    <div v-if="isFitPaid || billData.payType === 'K'" class="com-card-btn active">
                        {{ fitpayCard }}
                    </div>
                </div>
            </li>
            <li v-if="isFitPaid || billData.payType === 'K'">
                <span class="tit">카드번호 :</span>
                <div class="info d-flex align-items-center gap-2">
                    <input type="text" disabled :value="cardNumber(billData.npCardNum)" class="w220" />
                </div>
            </li>
            <li v-if="isFitPaid || billData.payType === 'K'">
                <span class="tit">승인번호 :</span>
                <div class="info">
                    <input type="text" disabled :value="billData.npAppNum" class="w220" />
                </div>
            </li>
            <li v-if="this.isUseReceipt && (this.billData.payType === 'L' || this.billData.payType === 'B')">
                <span class="tit">영수증발행 :</span>
                <div class="center-line">
                    <div class="com-radio">
                        <input
                            :id="`radio-money-${index}-1`"
                            v-model="billData.receiptType"
                            :disabled="mode === 'read'"
                            :name="`radio-money-${index}`"
                            type="radio"
                            value="N"
                            @click="onClickReceiptType($event)"
                        />
                        <label :for="`radio-money-${index}-1`">미신청</label>
                    </div>
                    <div class="com-radio">
                        <input
                            :id="`radio-money-${index}-2`"
                            v-model="billData.receiptType"
                            :disabled="mode === 'read'"
                            :name="`radio-money-${index}`"
                            type="radio"
                            value="C"
                            @click="onClickReceiptType($event)"
                        />
                        <label :for="`radio-money-${index}-2`">현금영수증</label>
                    </div>
                    <div class="com-radio">
                        <input
                            :id="`radio-money-${index}-3`"
                            v-model="billData.receiptType"
                            :disabled="mode === 'read'"
                            :name="`radio-money-${index}`"
                            type="radio"
                            value="T"
                            @click="onClickReceiptType($event)"
                        />
                        <label :for="`radio-money-${index}-3`">세금계산서</label>
                    </div>
                    <div class="input-line ml-4">
                        <input
                            v-model="billData.receiptNo"
                            :disabled="mode === 'read' || billData.receiptType === 'N'"
                            class="w220"
                            maxlength="14"
                            placeholder="번호입력"
                            type="text"
                            @input="onInputReceiptNo($event)"
                        />
                    </div>
                </div>
            </li>
            <li v-if="isUseMileage && billData.payType === 'M'">
                <span class="tit">보유 마일리지 :</span>
                <div class="center-line">
                    <div class="txt-info">{{ getMileage(mileage) | numberFormatFilter }} 원</div>
                    <div class="center">
                        <div class="com-check">
                            <input
                                id="check-mileage-1"
                                v-model="useAllMileage"
                                :disabled="mode === 'read'"
                                name="check-mileage"
                                type="checkbox"
                                @change="onChangeUseAllMileage"
                            />
                            <label for="check-mileage-1">모두사용</label>
                        </div>
                    </div>
                </div>
            </li>
            <li v-if="isUseMileage && billData.payType === 'M'">
                <span class="tit">사용 마일리지 :</span>
                <div class="info">
                    <input
                        :disabled="mode === 'read'"
                        class="w220"
                        type="text"
                        v-bind:value="getNumberFormat(billData.spendMileage)"
                        @input="onKeyUpSpendMileage"
                        @keypress="isNumber($event)"
                    />
                    <span class="txt">원</span>
                </div>
            </li>
            <li v-if="isUseMileage && billData.payType === 'M'">
                <span class="tit">마일리지 잔액 :</span>
                <div class="info">
                    <span class="txt-info">{{ remainMileage }} 원</span>
                </div>
            </li>
            <li v-if="billData.payType !== 'M' && billData.payType !== 'U'">
                <span class="tit">결제금액 :</span>
                <div class="info">
                    <input
                        v-model="billPrice"
                        :disabled="mode === 'read' || isFitSelected"
                        class="w220 ptype-not-u"
                        type="text"
                        @keypress="isNumber($event)"
                        @keyup="onKeyUpPrice"
                    />
                    <span class="txt">원</span>
                </div>
            </li>
            <li v-if="billData.payType === 'U'">
                <span class="tit">결제금액 :</span>
                <div class="info">
                    <input
                        v-model="billData.amt"
                        :disabled="mode === 'read'"
                        class="w220 ptype-u"
                        type="text"
                        @keypress="isNumber($event)"
                        @keyup="onKeyUpAmt"
                    />
                    <span class="txt">원</span>
                </div>
            </li>
            <li v-if="isFitPaid">
                <span class="tit">할부 :</span>
                <div class="info">
                    <input type="text" disabled :value="installMnt" class="w220 text-right" />
                </div>
            </li>
            <li v-if="billData.payType !== 'M'">
                <span class="tit">결제일자 :</span>
                <div class="info">
                    <single-calendar
                        :disabled="mode === 'read' || isFitSelected"
                        :start-date="billData.billDate"
                        class="w220"
                        @update="onUpdateBillDate"
                    ></single-calendar>
                </div>
            </li>
        </ul>
        <span v-if="isUseMileage" class="title">마일리지</span>
        <ul v-if="isUseMileage" class="info-list">
            <li class="pl-180">
                <span class="tit">적립 ({{ mileagePercent }}%) :</span>
                <div class="info">
                    <input
                        v-model="billData.acmltMileagePrice"
                        :disabled="mode === 'read'"
                        type="text"
                        @keypress="isNumber($event)"
                        @keyup="onKeyUpAcmltMileage"
                    />
                    <span class="txt">원 적립예정</span>
                    <!--billData.acmltMileagePrice-->
                    <div v-show="isUseMileageBtn" class="right-btn">
                        <button class="com-btn" style="margin-right: 15px">수정</button>
                        <button class="com-btn red">삭제</button>
                    </div>
                </div>
            </li>
        </ul>
        <div class="bottom-right-btn">
            <button v-if="isShowBtnDeletePayment" class="com-btn red" @click="onClickDelete">결제정보삭제</button>
        </div>

        <payment-info-dlg
            v-if="openPaymentHistoryDlg"
            :show="openPaymentHistoryDlg"
            :close="handleClosePaymentDlg"
            :select="handleSelectPayment"
        ></payment-info-dlg>
    </div>
</template>

<script>
import moment from 'moment';
import PaymentInfoDlg from './PaymentInfoDlg';
import { Utils } from '@/assets/js/utils';
import { NICEPAY_CARDS } from '../assets/js/common';

export default {
    name: 'paymentInfo',
    components: {
        PaymentInfoDlg,
    },
    props: {
        contractId: 0,
        max: {
            default: 0,
            type: [],
        },
        mode: '', // ('modify': 수정 전용, read: 읽기 전용, '': 최초 등록)
        isUseMileage: {
            default: true,
            type: Boolean,
        }, // 마일리지 사용여부 : 케어에서 미사용
        isUseMileageBtn: true, // 마일리지 수정버튼 사용여부
        isUseReceipt: true, // 현금영수증/세금계산서 사용여부
        mileage: 0, // 보유 마일리지
        index: 0,
        billData: {
            acmltMileagePrice: '',
        },
        isShowBtnDeletePayment: Boolean,
        taxTelNo: '',
        isContract: false,
        totalBuyPrice: 0,
        mileageInfo: {},
        fitpayMode: '',
        billCount: 0,
    },
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
        installMnt() {
            if (!this.billData.npInstallment) return '';
            if (this.billData.npInstallment === '00') return '일시불';
            return `${Number(this.billData.npInstallment)}개월`;
        },
        remainMileage() {
            return this.getNumberFormat(
                this.getPureNumber(this.getMileage(this.mileage)) - this.getPureNumber(this.billData.spendMileage)
            );
        },
        isShowBtnDelete() {
            return this.isShowBtnDeletePayment === undefined ? true : this.isShowBtnDeletePayment;
        },
        mileagePercent() {
            const mileageInfo = this.mileageInfo;
            const payType = this.billData.payType;
            if (Utils.isEmpty(mileageInfo)) {
                return '0.00';
            } else if (['C', 'T', 'U'].includes(payType) && mileageInfo.tickCardYn) {
                try {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(this.billPrice || this.billData.amt) *
                            Number(mileageInfo.ticketCardRatio)) /
                            100
                    );
                } catch (e) {}
                return mileageInfo.ticketCardRatio;
            } else if (payType === 'L' && mileageInfo.tickCashYn) {
                try {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(this.billPrice) * Number(mileageInfo.ticketCashRatio)) / 100
                    );
                } catch (e) {}

                return mileageInfo.ticketCashRatio;
            } else if (payType === 'B' && mileageInfo.tickBankYn) {
                try {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(this.billPrice) * Number(mileageInfo.ticketBankRatio)) / 100
                    );
                } catch {}

                return mileageInfo.ticketBankRatio;
            } else if (payType === 'E' && mileageInfo.tickEtcYn) {
                try {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(this.billPrice) * Number(mileageInfo.ticketEtcRatio)) / 100
                    );
                } catch {}
                return mileageInfo.ticketEtcRatio;
            }
            return '0.00';
        },
        isFitPaid() {
            return (
                (this.billData.payType === 'T' && !!this.billData.npTid) ||
                (this.billData.payType === 'U' && !!this.billData.npSmsId && !!this.billData.npTid)
            );
        },
        isFitSelected() {
            return ['T', 'U'].includes(this.billData.payType);
        },
        fitpayCard() {
            if (!this.billData.npCardType) return '';
            return NICEPAY_CARDS[this.billData.npCardType] || '';
        },
    },
    data() {
        return {
            targetPrice: 0,
            isMoreCard: false,
            cardType: [
                { title: 'KB국민카드', code: 'KB' },
                { title: '비씨', code: 'BC' },
                { title: '삼성', code: 'SM' },
                { title: '현대', code: 'HY' },
                { title: '롯데', code: 'LO' },
                { title: '신한', code: 'SH' },
                { title: '하나', code: 'HA' },
                { title: 'NH농협', code: 'NH' },
                { title: '외환', code: 'WR' },
                { title: '우리', code: 'WT' },
                { title: '기타', code: 'ET' },
            ],

            editFiledForPayInfo: {
                billDate: '', //
                price: '',
                amt: '',
                acmltMileagePrice: 0, // 적립 마일리지
                receiptType: 'N',
                receiptNo: '',
                spendMileage: 0,
                payCardType: '', //
                payBankType: '', //
            },
            useAllMileage: false, // 마일리지 모두 사용 체크박스
            count: 0,
            openPaymentHistoryDlg: false,
            billPrice: '',
        };
    },
    watch: {
        'billData.receiptType': function (value) {
            if (value === 'C' && this.texTelNo !== 0) {
                this.billData.receiptNo = this.taxTelNo;
            }
        },
        totalBuyPrice() {
            if (this.billCount > 1) return;

            this.targetPrice = Utils.getPureNumber(this.totalBuyPrice);
            if (this.billData.payType === 'U') {
                this.billData.amt = this.targetPrice;
            } else {
                this.billPrice = this.targetPrice;
            }
        },
        billPrice: function (newValue) {
            if (this.billData.payType !== 'M') {
                this.targetPrice = this.billData.billPrice || this.billData.npReqPrice;
            }

            if (this.billData.payType !== 'U') {
                if (this.contractId > 0 || this.count <= 0) {
                    this.count++;
                    this.billData.acmltMileagePrice = this.billData.mileage;
                } else {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(newValue) * Number(this.mileagePercent)) / 100
                    );
                }
            }
            this.onKeyUpPrice();
        },
        'billData.amt': function (newValue) {
            this.billData.amt = newValue;
            if (this.billData.payType === 'U') {
                if (this.contractId > 0 || this.count <= 0) {
                    this.count++;
                    this.billData.acmltMileagePrice = this.billData.mileage;
                } else {
                    this.billData.acmltMileagePrice = Math.floor(
                        (Utils.getPureNumber(newValue) * Number(this.mileagePercent)) / 100
                    );
                }
            }
            this.onKeyUpAmt();
        },
    },
    mounted() {
        this.targetPrice = this.billData.billPrice || this.billData.npReqPrice;

        if (this.billData.npReqPrice !== undefined) {
            this.billData.amt = this.getNumberFormat(this.billData.npReqPrice);
        }

        if (this.billData.billPrice !== undefined) {
            this.billPrice = this.getNumberFormat(this.billData.billPrice);
        }

        if (this.billData.billDate !== undefined) {
            this.billData.billDate = this.billData.billDate;
        } else {
            this.billData.billDate = this.today;
        }

        if (this.billData.payCardType !== undefined) {
            // 카드 결제시 결제사
            this.billData.payCardType = this.billData.payCardType;
        }
        if (this.billData.acmltMileagePrice !== undefined) {
            // 적립 예정 마일리지
            const num = this.getNumberFormat(this.billData.acmltMileagePrice);
            if (this.contractId > 0) {
                this.billData.acmltMileagePrice = this.billData.mileage || this.billData.npReqMileage;
            } else {
                this.billData.acmltMileagePrice = num;
            }
        }
        if (this.billData.receiptType != undefined) {
            // 영수증 발행 유형
            this.billData.receiptType = this.billData.receiptType;
        }
        if (this.billData.receiptNo != undefined) {
            // 영수증 발행 번호
            this.billData.receiptNo = this.autoAddDashPhoneNumber(this.billData.receiptNo);
        }
        if (this.billData.payType === 'M') {
            // 마일리지로 결제 했을때는 결제 금액을 사용 마일리지에 넣어줌
            this.billData.spendMileage = this.billData.billPrice;
            // this.billData.spendMileage = this.billData.billPrice;
        }
        // this.billData.acmltMileagePrice = parseFloat(this.mileagePercent) * this.billPrice
    },
    methods: {
        onChangePayType(newData) {
            // 결제수단 변경시 파라미터 정리
            if (this.billData.payType === 'T') {
                this.openPaymentHistoryDlg = true;
            }

            if (this.billData.payType === 'M') {
                this.billPrice = '0'; // 결제금액 초기화
                this.billData.billPrice = 0; // 결제금액 초기화
                this.billData.amt = '0'; //
                this.billData.npReqPrice = 0; //
                this.spendMileage = Math.min(this.mileage, this.targetPrice);
            } else if (this.billData.payType === 'U') {
                this.billPrice = '0'; // 결제금액 초기화
                this.billData.billPrice = 0; // 결제금액 초기화
                this.billData.npReqPrice = this.targetPrice;
                this.billData.amt = this.getNumberFormat(this.targetPrice);
                this.spendMileage = 0;
            } else {
                this.billData.amt = '0'; // 결제금액 초기화
                this.billData.npReqPrice = 0; // 결제금액 초기화
                this.billData.billPrice = this.targetPrice;
                this.billPrice = this.getNumberFormat(this.targetPrice);
                this.spendMileage = 0;
            }

            this.billData.acmltMileagePrice = 0; // 적립 마일리지 초기화
            this.billData.payCardType = ''; // 카드 타입 초기화
            this.billData.payBankType = ''; // 은행 타입 초기화
            this.billData.billDate = this.today; // 결제일자 초기화
            this.billData.receiptType = 'N'; // 영수증 발행 타입 초기화
            this.billData.receiptNo = ''; // 영수증 발행 번호 초기화

            this.billData.npTid = ''; // 핏페이 현장결제 거래아이디
            this.billData.npCardType = ''; // 핏페이 카드유형
            this.billData.npCardNum = ''; // 핏페이 카드번호
            this.billData.npAppNum = ''; // 핏페이 승인번호
            this.billData.npInstallment = ''; // 핏페이 할부

            this.useAllMileage = false; // 마일리지 모두 사용 체크박스 초기화
            this.onChange();
        },

        onChange() {
            this.$emit('on-change', {
                data: this.billData,
                index: this.index,
            });
        },
        onClickDelete() {
            this.$emit('on-click-delete', this.index);
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트
          console.log("PRICE 결제요청 금액 업데이트")
          console.log(this.billPrice)
            let num = this.getPureNumber(this.billPrice);
            try {
                const productPrice = this.getPureNumber(this.max[0].productBuyPrice);
                if (productPrice < num) {
                    num = productPrice;
                }
            } catch (e) {
            } finally {
                this.billData.billPrice = num;
                this.billPrice = this.getNumberFormat(num);
                // this.productBuyPrice = num;
            }
            // this.billData.acmltMileagePrice = Math.floor(Utils.getPureNumber(num) * Number(this.mileagePercent) / 100);
            // this.onChange();
        },
        onKeyUpAmt() {
            // 결제요청 금액 업데이트
          console.log("AMT 결제요청 금액 업데이트")
          console.log(this.billData.amt)
            let num = this.getPureNumber(this.billData.amt);
            try {
                const productPrice = this.getPureNumber(this.max[0].productBuyPrice);
                if (productPrice < num) {
                    num = productPrice;
                }
            } catch (e) {
            } finally {
                // this.billData.billPrice = num;
                this.billData.npReqPrice = num;
                this.billData.amt = this.getNumberFormat(num);
                // this.billData.productBuyPrice = num;
            }
            // this.billData.acmltMileagePrice = Math.floor(Utils.getPureNumber(num) * Number(this.mileagePercent) / 100);
            // this.onChange();
        },
        onKeyUpAcmltMileage() {
            // 적립 마일리지 업데이트
            const num = this.getPureNumber(this.billData.acmltMileagePrice);
            this.billData.acmltMileagePrice = num;
            this.billData.acmltMileagePrice = this.getNumberFormat(num);
            // this.onChange();
        },
        onUpdateBillDate(d) {
            // 결제일자 업데이트
            this.billData.billDate = d;
            this.billData.billDate = d;
            this.onChange();
        },
        onClickReceiptType(e) {
            // 영수증 발행 유형 업데이트
            this.billData.receiptType = e.target.value;
            this.onChange();
        },
        onInputReceiptNo(e) {
            // 영수증 발행 번호 업데이트
            const receiptNo = e.target.value;
            this.billData.receiptNo = receiptNo;
            this.billData.receiptNo = this.autoAddDashPhoneNumber(receiptNo);
            this.onChange();
        },
        onKeyUpSpendMileage(e) {
            // 사용 마일리지 업데이트
            if (e.target.value === '') {
                return;
            }

            let num = this.getPureNumber(e.target.value);
            if (num > this.mileage) {
                // 입력된 값 검사
                alert('보유 마일리지를 초과하여 입력할 수 없습니다.');
                e.target.value = '';
                num = 0;
            }
            this.billData.spendMileage = num;
            this.billData.billPrice = num;
            // this.billData.spendMileage = this.getNumberFormat(num);
            this.onChange();
        },
        // 보유 마일리지 모두 사용 체크시
        onChangeUseAllMileage() {
            if (this.useAllMileage === true) {
                const num = this.getPureNumber(this.mileage);
                this.billData.spendMileage = num;
                this.billData.billPrice = num;
            } else {
                this.billData.spendMileage = 0;
                this.billData.billPrice = 0;
            }

            this.onChange();
        },
        getPureNumber(num) {
            if (num === undefined || num === '') return 0;
            if (typeof num !== 'string') return num;

            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // 전화번호 입력시 자동 하이픈
        autoAddDashPhoneNumber(str) {
            const inputVal = str;
            return inputVal
                .replace(/[^0-9]/g, '')
                .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
                .replace('--', '-');
        },

        getMileage(mileage) {
            return Utils.isEmpty(mileage) ? 0 : Number(mileage);
        },

        handleSelectPayment(payment) {
            console.log("결제이력으로 부터 데이터 가져오기")
            if (!payment || !payment.nt_tid) return;
            console.log(payment)
            this.billData.npTid = payment.nt_tid;
            this.billData.npCardType = payment.nt_fn_cd;
            this.billData.npCardNum = payment.nt_payment_no;
            this.billData.npAppNum = payment.nt_app_no;
            this.billPrice = payment.nt_goods_amt || 0;
	    this.billData.price = payment.nt_goods_amt || 0;
            this.billData.billPrice = payment.nt_goods_amt || 0;
            this.billData.amt = payment.nt_goods_amt || 0;
            this.billData.npInstallment = payment.nt_install_mnt || null;
            this.billData.billDate = payment.nt_app_dt
                ? moment(payment.nt_app_dt, 'YYYYMMDD').format('YYYY-MM-DD')
                : this.today;

            this.openPaymentHistoryDlg = false;
            this.onChange();
        },

        handleClosePaymentDlg() {
            if (!this.billData.npTid) {
                this.billData.payType = 'C';
                this.onChangePayType('C');
            }
            this.openPaymentHistoryDlg = false;
        },

        cardNumber(num) {
            return Utils.formatCardNumber(num);
        },
    },
};
</script>
<style lang="scss"></style>
